import { Trans } from "@lingui/macro";
import { Box, Link, Skeleton } from "@mui/material";
import { ThemedText } from "src/theme/text";
import styled from "styled-components/macro";
import { ReactComponent as VYRO } from "src/assets/images/tokens/VYRO.svg";
import { ReactComponent as EsVYRO } from "src/assets/images/tokens/esVYRO.svg";
import { ReactComponent as USDT } from "src/assets/images/tokens/USDT.svg";
import { formatAmount2 } from "src/helpers/Helpers";
import { useGetVyroPrice } from "src/hooks/get_price_vyro";
import { useSelector } from "react-redux";
import { AssetBox } from "../AssetList";
import { BuyBtn } from "src/components/Button/BuyBtn";
import { ClaimBtn } from "src/components/Button/ClaimBtn";
import {
  useBalance_VYRO,
  useBalance_esVYRO,
  useBalance_usdc,
  useESTokenStakedV2Balance,
} from "src/hooks/useQueryEarn";
import { NavLink } from "react-router-dom";
import { BUY_VYRO_URL } from "src/constants/misc";
import { useWeb3Context } from "src/hooks";

const AssetMBox = styled(AssetBox)`
  margin-top: 24px;
  .assetItem-m {
    padding-bottom: 20px;
    .asset {
      padding: 16px 0;
      border-bottom: 1px dashed ${({ theme }) => theme.bg3};
    }
  }
  @media only screen and (max-width: 1180px) {
  }
`;

export default function AssetListM() {
  const VYROPrice = useGetVyroPrice();
  const usdcBalance = useBalance_usdc();
  const VYROBalance = useBalance_VYRO();
  const VYROStaked = 0;
  const esVYROBalance = useBalance_esVYRO();
  const esVYROStaked = useESTokenStakedV2Balance();
  const tokensArr = useSelector((state: any) => {
    return state?.app?.tokensArr || [];
  });
  const { chainID } = useWeb3Context();
  const handlerBuy = () => {
    chainID == 421614 && window.open(BUY_VYRO_URL[chainID]);
  };
  return (
    <AssetMBox className="">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className="assetHeader-m"
      >
        <Box className="">
          <ThemedText.Text4Bold>
            <Trans>Total</Trans>
          </ThemedText.Text4Bold>
        </Box>
        <Box className="text-right">
          <ThemedText.Text4Bold>
            <Trans>Total</Trans>
          </ThemedText.Text4Bold>
        </Box>
      </Box>
      <div className="assetItem-m">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className="asset"
        >
          <Box display="flex" alignItems="center" className="">
            <VYRO width={48} height={48} />
            <ThemedText.Text1Bold fontSize={24} ml="16px">
              <Trans>VYRO</Trans>
            </ThemedText.Text1Bold>
          </Box>
          <div className="">
            <ThemedText.Text1Medium fontSize={16}>
              {formatAmount2(
                VYROBalance?.plus(VYROStaked?.amount ? VYROStaked?.amount : 0),
                2,
                true
              )}
            </ThemedText.Text1Medium>
            <ThemedText.Text5 fontSize={12} mt="8px">
              $
              {formatAmount2(
                VYROBalance?.plus(
                  VYROStaked?.amount ? VYROStaked?.amount : 0
                ).times(VYROPrice ? VYROPrice : 1),
                2,
                true
              )}
            </ThemedText.Text5>
          </div>
        </Box>
        <Box display="flex" alignItems="center" mt="16px">
          <Box display="flex" alignItems="center" className="">
            <ThemedText.Text4Bold>
              <Trans>Wallet</Trans>
            </ThemedText.Text4Bold>
            <ThemedText.Text1Medium fontSize={16} ml="8px">
              {formatAmount2(VYROBalance, 2, true)}
            </ThemedText.Text1Medium>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            className="text-right"
            ml="24px"
          >
            <ThemedText.Text4Bold>
              <Trans>Staked</Trans>
            </ThemedText.Text4Bold>
            <ThemedText.Text1Medium fontSize={16} ml="8px">
              {formatAmount2(VYROStaked?.amount, 2, true)}
            </ThemedText.Text1Medium>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" mt="16px" className="">
          <Box className="flex-1">
            <Link component={NavLink} to={`/Earn?curr=${0}`}>
              <BuyBtn>Earn</BuyBtn>
            </Link>
          </Box>
          <Box className="flex-1" ml="16px">
            <ClaimBtn onClick={handlerBuy}>Buy / Sell</ClaimBtn>
          </Box>
        </Box>
      </div>
      <div className="assetItem-m">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className="asset"
        >
          <Box display="flex" alignItems="center" className="">
            <EsVYRO width={48} height={48} />
            <ThemedText.Text1Bold fontSize={24} ml="16px">
              <Trans>esVYRO</Trans>
            </ThemedText.Text1Bold>
          </Box>
          <div className="">
            <ThemedText.Text1Medium fontSize={16}>
              {formatAmount2(
                esVYROBalance?.plus(
                  esVYROStaked?.amount ? esVYROStaked?.amount : 0
                ),
                2,
                true
              )}
            </ThemedText.Text1Medium>
            <ThemedText.Text5 fontSize={12} mt="8px">
              $
              {formatAmount2(
                esVYROBalance
                  ?.plus(esVYROStaked?.amount ? esVYROStaked?.amount : 0)
                  .times(VYROPrice ? VYROPrice : 1),
                2,
                true
              )}
            </ThemedText.Text5>
          </div>
        </Box>
        <Box display="flex" alignItems="center" mt="16px">
          <Box display="flex" alignItems="center" className="">
            <ThemedText.Text4Bold>
              <Trans>Wallet</Trans>
            </ThemedText.Text4Bold>
            <ThemedText.Text1Medium fontSize={16} ml="8px">
              {formatAmount2(esVYROBalance, 2, true)}
            </ThemedText.Text1Medium>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            className="text-right"
            ml="24px"
          >
            <ThemedText.Text4Bold>
              <Trans>Staked</Trans>
            </ThemedText.Text4Bold>
            <ThemedText.Text1Medium fontSize={16} ml="8px">
              {formatAmount2(esVYROStaked?.amount, 2, true)}
            </ThemedText.Text1Medium>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" mt="16px" className="">
          <Box className="flex-1">
            <Link component={NavLink} to={`/Earn?curr=${0}`}>
              <BuyBtn>Earn</BuyBtn>
            </Link>
          </Box>
          <Box className="flex-1" ml="16px">
            <ClaimBtn disabled={true}>Buy / Sell</ClaimBtn>
          </Box>
        </Box>
      </div>
      {tokensArr?.length > 0 ? (
        tokensArr?.map((item, i) => (
          <div className="assetItem-m" key={i}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              className="asset"
            >
              <Box display="flex" alignItems="center" className="">
                <img src={item?.icon} width={48} height={48} />
                <ThemedText.Text1Bold fontSize={24} ml="16px">
                  {item?.name}
                </ThemedText.Text1Bold>
              </Box>
              <div className="">
                <ThemedText.Text1Medium fontSize={16}>
                  {formatAmount2(
                    item?.dlpBalance * 1 + item?.dlpBalanceStaked * 1,
                    2,
                    true
                  )}
                </ThemedText.Text1Medium>
                <ThemedText.Text5 fontSize={12} mt="8px">
                  $
                  {formatAmount2(
                    (item?.dlpBalance * 1 + item?.dlpBalanceStaked * 1) *
                      item?.price,
                    2,
                    true
                  )}
                </ThemedText.Text5>
              </div>
            </Box>
            <Box display="flex" alignItems="center" mt="16px">
              <Box display="flex" alignItems="center" className="">
                <ThemedText.Text4Bold>
                  <Trans>Wallet</Trans>
                </ThemedText.Text4Bold>
                <ThemedText.Text1Medium fontSize={16} ml="8px">
                  {formatAmount2(item?.dlpBalance, 2, true)}
                </ThemedText.Text1Medium>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                className="text-right"
                ml="24px"
              >
                <ThemedText.Text4Bold>
                  <Trans>Staked</Trans>
                </ThemedText.Text4Bold>
                <ThemedText.Text1Medium fontSize={16} ml="8px">
                  {formatAmount2(item?.dlpBalanceStaked, 2, true)}
                </ThemedText.Text1Medium>
              </Box>
            </Box>
            <Box display="flex" alignItems="center" mt="16px" className="">
              <Box className="flex-1">
                <Link component={NavLink} to={`/Earn?curr=${1}`}>
                  <BuyBtn>Earn</BuyBtn>
                </Link>
              </Box>
              <Box className="flex-1" ml="16px">
                <Link component={NavLink} to={`/Earn?curr=${1}`}>
                  <ClaimBtn>Buy / Sell</ClaimBtn>
                </Link>
              </Box>
            </Box>
          </div>
        ))
      ) : (
        <div className="flex-1">
          <Skeleton width="100%" height={60} style={{ borderRadius: "10px" }} />
        </div>
      )}
      <div className="assetItem-m">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className="asset"
        >
          <Box display="flex" alignItems="center" className="">
            <USDT width={48} height={48} />
            <ThemedText.Text1Bold fontSize={24} ml="16px">
              <Trans>USDT</Trans>
            </ThemedText.Text1Bold>
          </Box>
          <div className="">
            <ThemedText.Text1Medium fontSize={16}>
              {formatAmount2(usdcBalance, 2, true)}
            </ThemedText.Text1Medium>
            <ThemedText.Text5 fontSize={12} mt="8px">
              ${formatAmount2(usdcBalance, 2, true)}
            </ThemedText.Text5>
          </div>
        </Box>
        <Box display="flex" alignItems="center" mt="16px">
          <Box display="flex" alignItems="center" className="">
            <ThemedText.Text4Bold>
              <Trans>Wallet</Trans>
            </ThemedText.Text4Bold>
            <ThemedText.Text1Medium fontSize={16} ml="8px">
              {formatAmount2(usdcBalance, 2, true)}
            </ThemedText.Text1Medium>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            className="text-right"
            ml="24px"
          >
            <ThemedText.Text4Bold>
              <Trans>Staked</Trans>
            </ThemedText.Text4Bold>
            <ThemedText.Text1Medium fontSize={16} ml="8px">
              {formatAmount2(0, 2, true)}
            </ThemedText.Text1Medium>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" mt="16px" className=""></Box>
      </div>
    </AssetMBox>
  );
}
